import script from "./AddrForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./AddrForm.vue?vue&type=script&lang=ts&setup=true"

import "./AddrForm.vue?vue&type=style&index=0&id=7d4203bb&lang=scss"
import "./AddrForm.vue?vue&type=style&index=1&id=7d4203bb&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d4203bb"]])

export default __exports__